export const scrollToEnd = () => {
  document.getElementById('app')?.scrollBy({ left: 0, top: 9999, behavior: 'smooth' })
}

export const scrollToStart = () => {
  document.getElementById('app')?.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
}
